export const USER = {
  firstName: "Mohd faiz",
  lastName: "Khan",
  displayName: "Mohd Faiz",
  username: "mfaizk",
  gender: "male",
  pronouns: "he/him",
  bio: "Stay true to your own self",
  flipSentences: [
    "Creating with code. Small details matter.",
    "Design Engineer",
    "Open Source Contributor",
  ],
  address: "House no 647, Asothar road gazipur, fatehpur, UP, 212621",
  phoneNumber: "NzAwNzk2MTA0Nw==", // E.164 format, base64 encoded (https://t.io.vn/base64-string-converter)
  email: "c3VuZWF0ZXIxNDEzQGdtYWlsLmNvbQ==", // base64 encoded
  website: "https://mfaizk.netlify.app",
  // otherWebsites: [
  //   "https://dai.ng",
  //   "https://dai.so",
  //   "https://d.io.vn",
  //   "https://d.id.vn",
  //   "https://dai.io.vn",
  //   "https://dai.id.vn",
  //   "https://chanhdai.io.vn",
  //   "https://chanhdai.id.vn",
  //   "https://ncdai.vn",
  //   "https://ncdai.net",
  //   "https://dai.is-a.dev",
  // ],
  jobTitle: "Frontend Engineer",
  jobs: [
    {
      title: "Frontend Engineer",
      company: "TARALITY ECOSYSTEMS PRIVATE LIMITED",
      website: "https://tarality.com/",
    },
  ],
  about: `Hello, World! I’m Mohd Faiz Khan — a Front-End Developer passionate about crafting fast, secure, and user-friendly web experiences across both decentralized (Web3) and traditional (Web2) ecosystems.

With hands-on experience building dApps and centralized exchange (CEX) frontends, I specialize in transforming complex blockchain logic into clean, intuitive interfaces. I work extensively with React, Next.js, TypeScript, and modern front-end technologies to deliver high-performance applications users can trust.

From crypto trading platforms and wallet integrations to NFT dashboards and DeFi tools, I bring a deep understanding of Web3 workflows, smart contract interactions, and the challenges of building for a decentralized world — while also being grounded in the fundamentals of traditional frontend development.

Outside of work, I enjoy diving into emerging technologies, experimenting with new frameworks, and working on side projects that push the boundaries of what's possible on the web.

Let’s connect and build the next generation of digital experiences`,
  avatar: "https://avatars.githubusercontent.com/u/43818667?v=4 ",
  ogImage: "https://avatars.githubusercontent.com/u/43818667?v=4",
  // namePronunciationUrl: "https://assets.chanhdai.com/audio/chanhdai.mp3",
  keywords:
    "hire web3 frontend developer,  freelance react developer , crypto ui engineer,  faiz khan coder , blockchain frontend portfolio,  modern web developer,  nextjs + web3 developer,  frontend engineer for defi,  frontend engineer for dapps",
  dateCreated: "2025-09-15",
};
